// @flow
import React from 'react';
import {useParams} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import PageHeader from '../../../elements/PageHeader';
import EditVariantForm from './EditVariantForm/EditVariantForm';

type Props = {};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  content: {
    width: '100%',
    padding: theme.spacing(3),
  },
}));

const EditVariant = (props: Props) => {
  const classes = useStyles();

  const {id} = useParams();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <PageHeader
          backButton
          title={id === 'new' ? 'Nueva variante' : 'Editar variante'}
          backHref="/products-variants"
        />

        <EditVariantForm variantOptionId={id} />
      </div>
    </div>
  );
};

export default EditVariant;
